import '../../ApplicantInfo/applicant-info.scss';
import {useIntl} from "react-intl";
import {Modal} from "react-bootstrap";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface ReConfirmInfo{
    show: boolean;
    onHide: () => void;
    onConfirm?: () => void;
}

export function ModalReConfirm(props:ReConfirmInfo){
    const intl = useIntl();
    const {show, onHide, onConfirm} = props;
    const AceptInfo = (e: React.FormEvent) => {
        e.preventDefault();
        onConfirm?.();
        onHide();
    };
    return (
  <Modal
    show={show}
    onHide={onHide}
    centered
    dialogClassName="reconfirm-info-modal"
    aria-labelledby="reconfirm-info-title"
  >
    <form onSubmit={AceptInfo}>
      <Modal.Body>
        <div className="reconfirm-info-content">
          <div className="reconfirm-info-icon" aria-hidden="true">
            <CheckCircleOutlineIcon />
          </div>
          <h2 id="reconfirm-info-title" className="title-reConfirmInfo">
            {'Confirma tu información'}
          </h2>
          <p className="reconfirm-info-copy">
            {'Verifica que los datos sean correctos antes de continuar.'}
          </p>
          <div className="reconfirm-info-actions">
            <button type="button" className="reconfirm-info-button reconfirm-info-button--secondary" onClick={onHide}>
              {intl.formatMessage({ id: "button_cancel" })}
            </button>
            <button type="submit" className="reconfirm-info-button reconfirm-info-button--primary">
              {intl.formatMessage({ id: "button_continue" })}
            </button>
          </div>
        </div>
      </Modal.Body>
    </form>
  </Modal>
);

}
